import * as api from '../api/integrityCheck';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'PROCESS-MANAGER';

export const FETCH_INTEGRITY_CHECKS = createRequestTypes(
  `${prefix}/FETCH_INTEGRITY_CHECKS`,
);

export const fetchIntegrityChecks = makeApiActionCreatorV3(
  api.fetchIntegrityChecks,
  FETCH_INTEGRITY_CHECKS[START],
  FETCH_INTEGRITY_CHECKS[SUCCESS],
  FETCH_INTEGRITY_CHECKS[ERROR],
);

export const FETCH_INTEGRITY_CHECK = createRequestTypes(
  `${prefix}/FETCH_INTEGRITY_CHECK`,
);

export const fetchIntegrityCheck = makeApiActionCreatorV3(
  api.fetchIntegrityCheck,
  FETCH_INTEGRITY_CHECK[START],
  FETCH_INTEGRITY_CHECK[SUCCESS],
  FETCH_INTEGRITY_CHECK[ERROR],
);

export const RUN_INTEGRITY_CHECK = createRequestTypes(
  `${prefix}/RUN_INTEGRITY_CHECK`,
);

export const runIntegrityCheck = makeApiActionCreatorV3(
  api.runIntegrityCheck,
  RUN_INTEGRITY_CHECK[START],
  RUN_INTEGRITY_CHECK[SUCCESS],
  RUN_INTEGRITY_CHECK[ERROR],
);

export const CREATE_INTEGRITY_CHECK = createRequestTypes(
  `${prefix}/CREATE_INTEGRITY_CHECK`,
);

export const createIntegrityCheck = makeApiActionCreatorV3(
  api.createIntegrityCheck,
  CREATE_INTEGRITY_CHECK[START],
  CREATE_INTEGRITY_CHECK[SUCCESS],
  CREATE_INTEGRITY_CHECK[ERROR],
);

export const FETCH_INTEGRITY_CHECK_USERS = createRequestTypes(
  `${prefix}/FETCH_INTEGRITY_CHECK_USERS`,
);

export const fetchIntegrityCheckUsers = makeApiActionCreatorV3(
  api.fetchIntegrityCheckUsers,
  FETCH_INTEGRITY_CHECK_USERS[START],
  FETCH_INTEGRITY_CHECK_USERS[SUCCESS],
  FETCH_INTEGRITY_CHECK_USERS[ERROR],
);

export const ADD_INTEGRITY_CHECK_USER = createRequestTypes(
  `${prefix}/ADD_INTEGRITY_CHECK_USER`,
);

export const addIntegrityCheckUser = makeApiActionCreatorV3(
  api.addIntegrityCheckUser,
  ADD_INTEGRITY_CHECK_USER[START],
  ADD_INTEGRITY_CHECK_USER[SUCCESS],
  ADD_INTEGRITY_CHECK_USER[ERROR],
);

export const DELETE_INTEGRITY_CHECK_USER = createRequestTypes(
  `${prefix}/DELETE_INTEGRITY_CHECK_USER`,
);

export const deleteIntegrityCheckUser = makeApiActionCreatorV3(
  api.deleteIntegrityCheckUser,
  DELETE_INTEGRITY_CHECK_USER[START],
  DELETE_INTEGRITY_CHECK_USER[SUCCESS],
  DELETE_INTEGRITY_CHECK_USER[ERROR],
);

export const FETCH_PROCESS_LIST = createRequestTypes(
  `${prefix}/FETCH_PROCESS_LIST`,
);

export const fetchProcessList = makeApiActionCreatorV3(
  api.fetchProcessList,
  FETCH_PROCESS_LIST[START],
  FETCH_PROCESS_LIST[SUCCESS],
  FETCH_PROCESS_LIST[ERROR],
);

export const ADD_PROCESS_CHECK = createRequestTypes(
  `${prefix}/ADD_PROCESS_CHECK`,
);

export const addProcessCheck = makeApiActionCreatorV3(
  api.addProcessCheck,
  ADD_PROCESS_CHECK[START],
  ADD_PROCESS_CHECK[SUCCESS],
  ADD_PROCESS_CHECK[ERROR],
);

export const DELETE_PROCESS_CHECK = createRequestTypes(
  `${prefix}/DELETE_PROCESS_CHECK`,
);

export const deleteProcessCheck = makeApiActionCreatorV3(
  api.deleteProcessCheck,
  DELETE_PROCESS_CHECK[START],
  DELETE_PROCESS_CHECK[SUCCESS],
  DELETE_PROCESS_CHECK[ERROR],
);

export const FETCH_PROCESS_DETAILS = createRequestTypes(
  `${prefix}/FETCH_PROCESS_DETAILS`,
);

export const fetchProcessDetails = makeApiActionCreatorV3(
  api.fetchProcessDetails,
  FETCH_PROCESS_DETAILS[START],
  FETCH_PROCESS_DETAILS[SUCCESS],
  FETCH_PROCESS_DETAILS[ERROR],
);

export const FETCH_PROCESS_ERRORS = createRequestTypes(
  `${prefix}/FETCH_PROCESS_ERRORS`,
);

export const fetchProcessErrors = makeApiActionCreatorV3(
  api.fetchProcessErrors,
  FETCH_PROCESS_ERRORS[START],
  FETCH_PROCESS_ERRORS[SUCCESS],
  FETCH_PROCESS_ERRORS[ERROR],
);

export const FETCH_PROCESS_DETAIL_ERRORS = createRequestTypes(
  `${prefix}/FETCH_PROCESS_DETAIL_ERRORS`,
);

export const fetchProcessDetailErrors = makeApiActionCreatorV3(
  api.fetchProcessDetailErrors,
  FETCH_PROCESS_DETAIL_ERRORS[START],
  FETCH_PROCESS_DETAIL_ERRORS[SUCCESS],
  FETCH_PROCESS_DETAIL_ERRORS[ERROR],
);

export const FETCH_PROCESS_TYPES = createRequestTypes(
  `${prefix}/FETCH_PROCESS_TYPES`,
);

export const fetchProcessTypes = makeApiActionCreatorV3(
  api.fetchProcessTypes,
  FETCH_PROCESS_TYPES[START],
  FETCH_PROCESS_TYPES[SUCCESS],
  FETCH_PROCESS_TYPES[ERROR],
);

export const FETCH_INTEGRITY_CHECKS_BY_PROCESS = createRequestTypes(
  `${prefix}/FETCH_INTEGRITY_CHECKS_BY_PROCESS`,
);

export const fetchIntegrityChecksByProcess = makeApiActionCreatorV3(
  api.fetchIntegrityChecksByProcess,
  FETCH_INTEGRITY_CHECKS_BY_PROCESS[START],
  FETCH_INTEGRITY_CHECKS_BY_PROCESS[SUCCESS],
  FETCH_INTEGRITY_CHECKS_BY_PROCESS[ERROR],
);

export const CHANGE_PAGE = `${prefix}/CHANGE_PAGE`;
export const CHANGE_ROWS_PER_PAGE = `${prefix}/CHANGE_ROWS_PER_PAGE`;

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const changeRowsPerPage = (rowsPerPage) => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});
